module.exports = __webpack_public_path__ + "static/media/ball.42a4dd21.svg";